import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import DropZone from '../DropZone';

import {
  fetchUploadFile,
  fetchGetSkuImportTemplate,
  fetchGetLoadChestnyznakExcel,
} from '../../../actions/imports';

import { downloadFileViaDirectLink, parseError, saveOctetStreamAsFile } from '../../../helpers';
import { fetchImportChestnyznakUniqNumbersExcel } from '../../../actions/items';
import { useHistory } from 'react-router-dom';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const templateTypes = {
  ORDER: 'order',
  SKU: 'sku',
};

const UploadFile = (props) => {
  const { templateType, withoutTemplate, templateFileName, setImportData, importType } = props;

  const { t } = useAutoTranslation();

  const dispatch = useDispatch();
  const history = useHistory();

  const [isUploading, setIsUploading] = useState(false);

  const uploadXls = (files) => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append('templateType', templateType);
    formData.append('upfile', files[0]);
    dispatch(fetchUploadFile(formData))
      .then((result) => {
        setImportData(result);
      })
      .catch((error) => {
        toast.error(parseError(error));
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  const uploadChzFile = (files) => {
    setIsUploading(true);
    dispatch(fetchImportChestnyznakUniqNumbersExcel(files[0], null, 'excel'))
      .then((result) => {
        setImportData(result);
        toast.info(t('Импорт успешно завершен!'));
        setTimeout(() => history.push('/imports?import-chz'), 500);
      })
      .catch((error) => {
        toast.error(parseError(error));
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  const handleGetChzTemplate = async () => {
    const res = await dispatch(fetchGetLoadChestnyznakExcel());
    const json = await new Response(res.data).text();
    const downloadUrl = JSON.parse(json).fileUrl;
    downloadFileViaDirectLink(downloadUrl);
  };

  const handleGetTemplate = async () => {
    const blob = await dispatch(fetchGetSkuImportTemplate(templateTypes[templateType]));
    saveOctetStreamAsFile({ content: blob, fileName: `${templateFileName}.xls` });
  };

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-6">
          <div className="form-inline">
            <div className="form-group">
              <span className="number-circle mr-2">1</span>
              <span>{t('Выберите файл')}</span>
            </div>
          </div>
        </div>
        {!withoutTemplate ? (
          <div className="col-sm-6">
            <div className="text-sm-right">
              <button
                type="button"
                className="btn btn-light waves-effect waves-light"
                onClick={importType === 'chz' ? handleGetChzTemplate : handleGetTemplate}
              >
                <i className="fe-file-text"></i> {t('Скачать шаблон')}
              </button>
            </div>
          </div>
        ) : null}
      </div>
      <div className="row mb-4">
        <div className="col-12">
          <div className="files-wrapper">
            <DropZone
              handleFileDrop={importType === 'chz' ? uploadChzFile : uploadXls}
              showDescription={true}
              dropzoneDescription={t(
                'Перетащите сюда файл в формате .xls/.xlsx или кликните для его выбора',
              )}
              isSingle={true}
              isUploading={isUploading}
              accept={['.xls', '.xlsx']}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default UploadFile;
